
(function(){
  var state={look:'all',format:'all',wear:'all',q:'',sort:'featured'};
  var grid=document.getElementById('productGrid');
  if(!grid) return;
  var empty=document.getElementById('filterEmpty');
  var countEl=document.getElementById('resultCount');
  var search=document.getElementById('collectionSearch');
  var sortSel=document.getElementById('collectionSort');
  var lookOrder={Natural:0,Wispy:1,Dramatic:2};
  function cards(){ return [].slice.call(grid.querySelectorAll('.product-card')); }
  function matchesSearch(c, q){
    if(!q) return true;
    var hay=[c.dataset.name||'', c.dataset.look||'', c.dataset.format||'', c.dataset.wear||'', (c.querySelector('.meta')&&c.querySelector('.meta').textContent)||'']
      .join(' ').toLowerCase();
    return hay.indexOf(q) !== -1;
  }
  function sortCards(list){
    var mode=state.sort;
    return list.slice().sort(function(a,b){
      var na=(a.dataset.name||'').toLowerCase();
      var nb=(b.dataset.name||'').toLowerCase();
      if(mode==='name-asc') return na.localeCompare(nb);
      if(mode==='name-desc') return nb.localeCompare(na);
      if(mode==='look'){
        var la=lookOrder[a.dataset.look]; if(la==null) la=9;
        var lb=lookOrder[b.dataset.look]; if(lb==null) lb=9;
        if(la!==lb) return la-lb;
        return na.localeCompare(nb);
      }
      return Number(a.dataset.feat)-Number(b.dataset.feat);
    });
  }
  function apply(){
    var q=(state.q||'').trim().toLowerCase();
    var all=cards();
    all.forEach(function(c,i){ if(c.dataset.feat==null) c.dataset.feat=String(i); });
    var visible=[];
    all.forEach(function(c){
      var ok=(state.look==='all'||c.dataset.look===state.look)
        &&(state.format==='all'||c.dataset.format===state.format)
        &&(state.wear==='all'||c.dataset.wear===state.wear)
        && matchesSearch(c,q);
      c.classList.toggle('is-hidden', !ok);
      if(ok) visible.push(c);
    });
    sortCards(visible).forEach(function(c){ grid.appendChild(c); });
    if(empty) empty.classList.toggle('is-visible', visible.length===0);
    if(countEl){
      var bits=[visible.length+' '+(visible.length===1?'style':'styles')+' shown'];
      if(q) bits.push('search "'+state.q.trim()+'"');
      if(state.sort && state.sort!=='featured' && sortSel) bits.push('sort: '+sortSel.options[sortSel.selectedIndex].text);
      countEl.textContent=bits.join(' · ');
    }
  }
  document.querySelectorAll('.chip[data-filter]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var g=btn.getAttribute('data-filter');
      var v=btn.getAttribute('data-value');
      state[g]=v;
      document.querySelectorAll('.chip[data-filter="'+g+'"]').forEach(function(b){b.classList.toggle('is-active', b===btn);});
      apply();
    });
  });
  if(search){ search.addEventListener('input', function(){ state.q=search.value; apply(); }); }
  if(sortSel){ sortSel.addEventListener('change', function(){ state.sort=sortSel.value; apply(); }); }
  apply();
})();
